import redirectInterceptor from "@/interceptors/redirect_interceptor";

const state = () => ({
  activeZones: {},
  loading: false,
  error: null,
});

const getters = {
  getActiveZones(state) {
    return Object.values(state.activeZones);
  },
  isZoneActive: (state) => (zoneType) => {
    return Boolean(state.activeZones[zoneType]);
  },
};

const actions = {
  async loadZone({ state, commit }, payload) {

    const zoneType = payload.zoneType
      .toLowerCase()
      .replace(/\s+/g, "_");

    // TOGGLE OFF
    if (state.activeZones[zoneType]) {
      commit("REMOVE_ACTIVE_ZONE", zoneType);
      return;
    }

    commit("SET_LOADING");

    try {
      const response = await redirectInterceptor.get(
        "https://nav.theyr.com/v1.2/worlddata",
        {

          params: {
            type: zoneType,
          },
        }
      );

      const geojson = response.data;

      // Keep ONLY polygons
      const filteredGeojson = {
        type: "FeatureCollection",
        features: geojson.features.filter(
          (f) =>
            f.geometry &&
                        (f.geometry.type === "Polygon" ||
                            f.geometry.type === "MultiPolygon")
        ),
      };

      commit("ADD_ACTIVE_ZONE", {
        type: zoneType,
        geojson: filteredGeojson,
      });

      commit("SET_SUCCESS");

    } catch (error) {
      commit("SET_ERROR", error.message);
    }
  },
};

const mutations = {

  ADD_ACTIVE_ZONE(state, { type, geojson }) {
    const zoneColors = {
      eca: "#ff0000",
      neca: "#ff8800",
      seca: "#ffd600",
      high_risk_areas: "#c76ffa",
      marpol: "#2600ff",
      rec_shipping_lanes: "#26a69a",
      loadline_zones: "#00acc1",
      nav_limits: "#26a69a",
      jwla: "#43a047",
      vra: "#f0f0f0",
      whale_protection_areas: "#ab47bc"
    };

    const color = zoneColors[type] || "#ff3b3b";

    state.activeZones = {
      ...state.activeZones,
      [type]: {
        type,
        geojson: {
          type: "geojson",
          data: geojson,
        },
        fillLayer: {
          id: `zone-fill-${type}`,
          type: "fill",
          paint: {
            "fill-color": color,
            "fill-opacity": 0.25,
            "fill-outline-color": color
          },
        },
      },
    };
  },

  REMOVE_ACTIVE_ZONE(state, type) {
    const updated = { ...state.activeZones };
    delete updated[type];
    state.activeZones = updated;
  },
  CLEAR_ACTIVE_ZONES(state) {
    state.activeZones = {};
    state.loading = false;
    state.error = null;
  },

  SET_LOADING(state) {
    state.loading = true;
    state.error = null;
  },

  SET_SUCCESS(state) {
    state.loading = false;
    state.error = null;
  },

  SET_ERROR(state, error) {
    state.loading = false;
    state.error = error;
  },
};

export const weatherRoutingSpecialZonesModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
